module.exports = __webpack_public_path__ + "static/media/Times New Roman-01.03f83cf9.svg";